module.exports = __webpack_public_path__ + "media/fresh-and-delicious.227007ab.mp4";